import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import {
  PHOTO_PLACEMENT_CHANGED_ON_SPREAD_EVENT,
  flushScheduledAlbumPhotosRefresh,
  scheduleAlbumPhotosRefresh,
} from '@/lib/photos/schedule-album-photos-refresh'

/**
 * Refreshes the selected album's photos (their `placedFlag`) whenever a photo placement changes
 * on the spread; a pending refresh is flushed when the album/spread changes or the tray unmounts.
 */
export function useAlbumPhotosPlacementRefresh(albumValue: string | null, spreadId: string | null) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!albumValue) return

    const queryKey = queryKeys.photos.albumPhotos(albumValue, spreadId)

    const onPhotoPlacementChanged = () => {
      scheduleAlbumPhotosRefresh(queryClient, queryKey)
    }

    window.addEventListener(PHOTO_PLACEMENT_CHANGED_ON_SPREAD_EVENT, onPhotoPlacementChanged)
    return () => {
      window.removeEventListener(PHOTO_PLACEMENT_CHANGED_ON_SPREAD_EVENT, onPhotoPlacementChanged)
      flushScheduledAlbumPhotosRefresh(queryKey)
    }
  }, [albumValue, queryClient, spreadId])
}
